import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, BaseCommonComponent, UserService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-promet-kase',
    templateUrl: './promet-kase.component.html'
})
export class PrometKaseComponent extends BaseCommonComponent
  implements OnInit {


    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected userService: UserService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }

    ngOnInit() {
        super.ngOnInit();

        let dateNow = new Date();
        this.baseFormGroup = new FormGroup({
            OdDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, 1), [Validators.required]),
            DoDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
            VrstaIzvestaja: new FormControl("1", [Validators.required]),
        })
    }

}
